<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Opisy faktur</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
		  <div class="row mb-3">
			<div class="col-md-4">
			  <input
			    v-model="search"
			    type="text"
			   class="form-control"
			    placeholder="Szukaj (numer, dostawca, opis...)"
			  />
		    </div>
		  </div>
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover table-bordered w-100">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Numer faktury</th>
                  <th>Data wystawienia</th>
                  <th>Dostawca</th>
				  <th>Opis</th>
                  <th>Opcje</th>
				</tr>
                </thead>
				<tbody>
				 <tr v-for="(faktura, index) in filteredFaktury" :key="faktura.id">
					<td>{{ index + 1 }}</td>
					<td>
					  {{ faktura.numer }}
					  <div class="mt-1">
						<span 
						  class="badge"
						  :class="{
							'bg-success': faktura.opis && faktura.opis.length >= 3,
							'bg-danger': !faktura.opis || faktura.opis.length < 3
						  }"
						>
						  {{ faktura.opis && faktura.opis.length >= 3 ? 'Opis dodany' : 'Brak opisu' }}
						</span>
					  </div>
					</td>
					<td>{{ formatDate(faktura.data) }}</td>
					<td style="white-space: pre-line;">{{ faktura.dostawca }}</td>
					<td :title="faktura.opis">{{ shortOpis(faktura.opis) }}</td>
					<td class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
					  <button @click="editFaktura(faktura)" class="btn btn-sm btn-outline-info">
						<i class="bi bi-pencil me-2"></i>Dodaj opis
					  </button>

					  <span v-if="faktura.faktura_id">
						<a
						  v-if="faktura.faktura_id && faktura.faktura_upo"
						  :href="faktura.faktura_upo"
						  target="_blank"
						  rel="noopener noreferrer"
						  class="btn btn-info btn-sm"
						>
						  <i class="bi bi-file-earmark-pdf"></i>
						  Pobierz
						</a>
					  </span>
					</td>

				  </tr>
				</tbody>
              </table>
            </div>
          </div>

          <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Edycja danych faktury</h5>
                  <button type="button" class="btn-close" @click="closeEditModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="numer">Numer faktury: {{editedFaktura.numer}}</label>
					  
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="data">Data wystawienia: {{editedFaktura.data}}</label>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="dostawca">Dostawca: {{editedFaktura.dostawca}}</label>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label" for="opis">Opis:</label>
                      <textarea id="opis" v-model="editedFaktura.opis" class="form-control" rows="10"></textarea>
                    </div>   

					<hr />

					<h6 class="mt-3">Załączone pliki</h6>
					  <span v-if="editedFaktura.faktura_id">
						<a
						  v-if="editedFaktura.faktura_id && editedFaktura.faktura_upo"
						  :href="editedFaktura.faktura_upo"
						  target="_blank"
						  rel="noopener noreferrer"
						  class="btn btn-info btn-sm"
						>
						  <i class="bi bi-file-earmark-pdf"></i>
						  Pobierz fakturę
						</a>
					  </span>
					<ul class="list-group mt-2">
					  <li v-if="isLoadingFiles" class="list-group-item text-center">
						<div class="spinner-border spinner-border-sm me-2"></div>
						Ładowanie plików...
					  </li>

					  <li
						v-for="file in files"
						:key="file.id"
						class="list-group-item d-flex justify-content-between align-items-center"
					  >
						<span class="text-truncate" :title="file.name">
						  {{ file.name }}
						</span>

						<a
						  class="btn btn-sm btn-outline-primary"
						  :href="route('kadry.opisy_faktur.files.download', file.id)"
						>
						  <i class="bi bi-download me-1"></i>
						  Pobierz
						</a>
					  </li>

					  <li v-if="!files.length && !isLoadingFiles" class="list-group-item">
						<i>Brak załączonych plików</i>
					  </li>
					</ul>
					
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditModal">Anuluj</button>
                  <button class="btn btn-primary" @click="updateFaktura(editedFaktura)">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";

export default {
  components: {AppLayout},
  props: {
    listaFaktur: Array
  },
  data() {
    return {
      editingId: null,
	  search: '',
      editedFaktura: {},
      isEditModalOpen: false,
      listFakturLocal: [...this.listaFaktur],
      files: [],
      isLoadingFiles: false,
    };
  },
  watch: {
    listaFaktur: {
      handler(nowe) {
        this.listFakturLocal = [...nowe]; // aktualizacja jeśli props się zmieni
      },
      immediate: true
    }
  },
computed: {
  filteredFaktury() {
    let list = this.listFakturLocal;

    // 1️⃣ filtr wyszukiwania
    if (this.search) {
      const s = this.search.toLowerCase();
      list = list.filter(f => {
        return (
          (f.numer && f.numer.toLowerCase().includes(s)) ||
          (f.dostawca && f.dostawca.toLowerCase().includes(s)) ||
          (f.opis && f.opis.toLowerCase().includes(s))
        );
      });
    }

    // 2️⃣ sortowanie: brak opisu na górze, potem według daty malejąco
    list.sort((a, b) => {
      const aNoOpis = !a.opis || a.opis.length < 3;
      const bNoOpis = !b.opis || b.opis.length < 3;

      if (aNoOpis && !bNoOpis) return -1; // brak opisu na górze
      if (!aNoOpis && bNoOpis) return 1;

      // potem sortowanie po dacie malejąco (najnowsze na górze)
      const dateA = a.data ? new Date(a.data) : new Date(0);
      const dateB = b.data ? new Date(b.data) : new Date(0);

      return dateB - dateA;
    });

    return list;
  }
},

  methods: {
  shortOpis(opis) {
  if (!opis) return '';

  return opis.length > 30
    ? opis.substring(0, 30) + '...'
    : opis;
},

  async getAttachments() {
  if (!this.editedFaktura?.id) return;

  this.isLoadingFiles = true;

  try {
    const res = await axios.get(
      route('kadry.opisy_faktur.files.index', this.editedFaktura.id)
    );

    this.files = res.data.files;
  } finally {
    this.isLoadingFiles = false;
  }
},

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // miesiące 0-11
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
  
    closeEditModal() {
      this.isEditModalOpen = false;
    },

    getEmptyForm() {
      return {
        id: null,
        numer: '',
        data: '',
        dostawca: '',
        opis: '',
      };
    },

    editFaktura(faktura) {
      this.editingId = faktura.id;
      this.isEditModalOpen = true;
      this.editedFaktura = { ...faktura };
	  this.getAttachments();
    },

    updateFaktura(editfaktura) {
      this.$inertia.put(route('warehouse.opisy_faktur.update', editfaktura.id), editfaktura, {
        onSuccess: () => {
          const idx = this.listFakturLocal.findIndex(w => w.id === editfaktura.id);
          if (idx !== -1) {
            this.listFakturLocal[idx] = { ...editfaktura };
          }
          this.editingId = null;
          this.isEditModalOpen = false;
        }
      });
    }

  }
};
</script>
<style scoped>
</style>
